import { render } from "./install-modal.vue?vue&type=template&id=5c59e2ab&scoped=true&ts=true"
import script from "./install-modal.vue?vue&type=script&lang=ts"
export * from "./install-modal.vue?vue&type=script&lang=ts"

import "./install-modal.vue?vue&type=style&index=0&id=5c59e2ab&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c59e2ab"]])